// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"1dd9eafa","453":"a8ca739f"}[chunkId] + ".chunk.js";
};